import type {
  HistoryEventDirection,
  HistoryRevertibility,
  HistoryTrackedTable,
} from "../types";

type SimpleBlockedReason = Exclude<
  Extract<HistoryRevertibility, { state: "blocked" }>,
  { reason: "conflicts" }
>["reason"];

// Keys under smartSurveyor.history.blocked for the reasons that need no detail.
export const BLOCKED_REASON_KEYS: Record<SimpleBlockedReason, string> = {
  kind_not_revertible: "kind",
  not_newest_in_chain: "notNewest",
  chain_too_long: "chainTooLong",
  plan_deleted: "planDeleted",
  diagram_deleted: "diagramDeleted",
  parent_missing: "parentMissing",
};

// Keys under smartSurveyor.history.blocked when a later entry is in the way.
export const CHANGED_LATER_KEYS = {
  byYou: "changedLaterByYou",
  byOther: "changedLater",
} as const;

export const ADDED_LATER_KEYS = {
  byYou: "addedLaterByYou",
  byOther: "addedLaterBy",
} as const;

// A row the undo would put back clashes with one made since; any other table means a same-named type.
export const UNIQUE_CONFLICT_KEYS: Partial<
  Record<HistoryTrackedTable, string>
> = {
  approvals: "approvedAgain",
  cableTrayVerdicts: "verdictSetAgain",
  // The thread holds the one-per-marker key; its comments have none.
  elementMarkerCommentThreads: "noteSetAgain",
};

export const PRICE_TABLES: ReadonlySet<HistoryTrackedTable> = new Set([
  "itemTypeMaterialPrices",
  "itemTypeInstallationPrices",
]);

// A row whose parent is gone; tables not listed hang off a type (or a setting, for prices).
export const PARENT_MISSING_KEYS: Partial<Record<HistoryTrackedTable, string>> =
  {
    elementMarkerCommentThreads: "markerMissing",
    elementMarkerComments: "markerMissing",
  };

// Keys under smartSurveyor.history; your own events get their own sentence for German grammar.
export const LAST_EVENT_KEYS: Record<
  HistoryEventDirection,
  Record<"byYou" | "byOther", string>
> = {
  undo: { byYou: "undoneByYou", byOther: "undoneBy" },
  redo: { byYou: "redoneByYou", byOther: "redoneBy" },
};

export const ADMIN_AVATAR_CLASS = "bg-gray-200 text-gray-700";

export const AVATAR_CLASSES = [
  "bg-indigo-100 text-indigo-700",
  "bg-emerald-100 text-emerald-700",
  "bg-amber-100 text-amber-700",
  "bg-sky-100 text-sky-700",
  "bg-rose-100 text-rose-700",
];
